import { StatusBadge } from "@/components/common/ui-kit";
import { fmtMinutes } from "@/lib/interventions";

export const REP_STATUS = {
  bozza: ["Bozza", "neutral"], inviato: ["Inviato", "blue"], confermato: ["Confermato", "green"],
  in_rettifica: ["In rettifica", "amber"], annullato: ["Annullato", "neutral"],
};
export const ECON_STATUS = {
  non_valorizzato: ["Non valorizzato", "neutral"], non_fatturabile: ["Non fatturabile", "neutral"], fatturabile: ["Fatturabile", "brand"], coperto_da_pacchetto: ["Coperto da pacchetto", "green"],
  parzialmente_fatturabile: ["Parzialmente fatturabile", "amber"], da_rettificare: ["Da rettificare", "red"], annullato: ["Annullato", "neutral"],
};
export const PKG_STATE = { attivo: ["Attivo", "green"], esaurito: ["Esaurito", "neutral"], scaduto: ["Scaduto", "red"], chiuso: ["Chiuso", "neutral"] };
export const RATE_SOURCE = { rapportino: "Tariffa specifica del rapportino", cliente: "Tariffa cliente", tipologia: "Tariffa per tipologia", standard: "Tariffa standard" };

const Badge = ({ map, value, testId }) => { const [l, t] = map[value] || [value, "neutral"]; return <StatusBadge tone={t} data-testid={testId}>{l}</StatusBadge>; };
export const ReportStatus = ({ status, testId }) => <Badge map={REP_STATUS} value={status} testId={testId} />;
export const EconStatus = ({ status, testId }) => (status ? <Badge map={ECON_STATUS} value={status} testId={testId} /> : null);
export const BILLING = { da_fatturare: ["Da fatturare", "amber"], fatturato: ["Fatturato", "green"] };
export const billingOf = (rep) => (rep.status === "confermato" && ["fatturabile", "parzialmente_fatturabile"].includes(rep.economic_status) ? rep.billing_status || "da_fatturare" : null);
export const BillingStatus = ({ rep, testId }) => (billingOf(rep) ? <Badge map={BILLING} value={billingOf(rep)} testId={testId} /> : null);
export const PkgState = ({ state, testId }) => <Badge map={PKG_STATE} value={state} testId={testId} />;

const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });
export const fmtEur = (v) => eur.format(v || 0);
export const fmtHours = (h) => fmtMinutes(Math.round(Number(h || 0) * 60));
export const minToHours = (m) => (m == null ? "—" : fmtHours(m / 60));
